import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { Link } from 'gatsby';

const styles = {
    card: {
        display: 'inline-block',
        width: '100%',
        minHeight: '200px',
    },
    title: {
        marginBottom: 16,
        fontSize: 16,
    },
    pos: {
        marginBottom: 12,
    },
};

function MACard(props) {
    const { classes } = props;

    return (
        <Card className={classes.card}>
            <CardContent>
                <Typography variant="headline" component="h2">
                    <Link to="/manager-agents/installation/release-notes">Release Notes</Link>
                </Typography>
                <Typography component="p">
                    Read about new features and information about the latest release of Manager+Agents
                </Typography>
            </CardContent>
            <CardActions>
                <Link to="/manager-agents/installation/release-notes"> </Link>
            </CardActions>
        </Card>
    );
}

MACard.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MACard);
